<div class="flex flex-col items-center justify-center h-full w-full gap-4 text-gray-500">
	<ui-icon width="36" height="36" iconName="info-box" />

	<h4 class="text-xl font-bold">صفحه مورد نظر یافت نشد</h4>
</div>
